<script>
    export default {

        name: 'FaqVote',

        data() {
            return {
                vote: 0,
            }
        },

        methods: {
            thumbsUp: function(id) {
                this.vote = 1;
                this.postSupportVote(id, 'true');
            },

            thumbsDown: function(id) {
                this.vote = -1;
                this.postSupportVote(id, 'false');
            },

            postSupportVote: function(id, helpful) {
                let data = {
                    label: id,
                    helpful: helpful
                }

                gtmGaEvent(
                    'Support feedback',
                    (helpful ? 'Helpful' : 'Not helpful'),
                    id,
                    helpful
                );

                return this.$http.post('/support', data).then((response) => {
                    return response.data;
                })
            }
        },
    }
</script>
